import { Component } from '@angular/core';

/**
 * Short, collapsible explanation of the answer display (symbols and labels), used in the demo only.
 * Uses the native <details>/<summary> element: it is reachable and operable with
 * Tab, Enter and Space, and screen readers announce expanded / collapsed natively.
 */
@Component({
  selector: 'app-answer-legend',
  templateUrl: './answer-legend.component.html',
  styleUrls: ['./answer-legend.component.scss']
})
export class AnswerLegendComponent { }
